import { render, staticRenderFns } from "./AuswahlWerte.vue?vue&type=template&id=61843706&scoped=true&"
import script from "./AuswahlWerte.vue?vue&type=script&lang=js&"
export * from "./AuswahlWerte.vue?vue&type=script&lang=js&"
import style0 from "./AuswahlWerte.vue?vue&type=style&index=0&id=61843706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61843706",
  null
  
)

export default component.exports